import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { MetaService } from 'src/app/Services/meta-data.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';
import { ProductsService } from '../../Services/product.service';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'embryo-NotFound',
  templateUrl: './NotFound.component.html',
  styleUrls: ['./NotFound.component.scss'],
})
export class NotFoundComponent implements OnInit , OnDestroy {
  lang: any;
  environmentVariables: any;
  constructor(
    public embryoService: EmbryoService,
    private metaService: MetaService,
    private confgServ: StaticPagesService,
     private route: ActivatedRoute,
     public productService : ProductsService,
        private router: Router,
        private meta: Meta

  ) {
    this.confgServ.getenvConfig().subscribe((res) => {
      this.environmentVariables = res;
    });
    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
      if (this.lang == 'en')
        this.metaService.setTitle(
          `Not Found - ${this.environmentVariables?.APP_NAME}`
        );
      else
        this.metaService.setTitle(
          `غير موجوده - ${this.environmentVariables?.APP_NAME_AR}`
        );
    });
  }
  ngOnInit(): void {
        //   const segments = this.router.url.split('/');
        // // segments[2] = 'produtcs';
        // segments.splice(2, 0, 'produtcs');
        // const newUrl = segments.join('/');
        // this.router.navigateByUrl(newUrl);
        // document.getElementById("Index-Follow")?.setAttribute('content' , "nofollow")
        // document.getElementById("Index-Follow")?.remove();
        this.meta.addTags([
          { name: 'robots', content: 'noindex' },
          { name: 'robots', content: 'nofollow' },
          { name: 'robots', content: 'none' },
          { name: 'robots', content: 'noarchive' },
          { name: 'googlebot-image', content: 'noindex' },
          { name: 'MSNBot-Media', content: 'noindex' }
        ]);



     this.route.queryParams.subscribe((params) => {
                let hasVariant  = Number(params["variant"]);
                // console.log(hasVariant);
                if(hasVariant){
                  this.productService.getComparedProductById(hasVariant).subscribe(res=>{
                     if(res.code == 200){
                      this.router.navigate([`${this.lang}/${res.data.product.slug}`])
                     }
                  })
                }
                
        })
  
}

ngOnDestroy() {
  this.meta.removeTag('name="robots"');
  this.meta.removeTag('name="googlebot-image"');
  this.meta.removeTag('name="MSNBot-Media"');
  // document.getElementById("Index-Follow")?.setAttribute('content' , "INDEX,FOLLOW")
}
}
